import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import { isUiMobile } from '@/redux/modules/browser';
import { openFeedbackModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import styled from 'styled-components';

const FeedbackLink = () => {
    const dispatch = useAppDispatch();
    const mobile = useAppSelector(isUiMobile);
    const whiteLabel = useAppSelector(getIsWhiteLabel);
    const { pathname } = useLocation();
    const isCheckoutPage = pathname.includes('checkout');

    const formLinkClick = React.useCallback(() => {
        dispatch(openFeedbackModal());
    }, [dispatch]);

    const showWidget = !mobile && !whiteLabel && !isCheckoutPage;

    if (!showWidget) {
        return null;
    }

    return (
        <StyledFeedbackLink id="desk-form-link-container">
            <StyledActionText onClick={formLinkClick}>
                <FormattedMessage id="feedback.feedback" />
            </StyledActionText>
        </StyledFeedbackLink>
    );
};

export default FeedbackLink;

const StyledFeedbackLink = styled.div`
    background-color: ${({ theme }) => theme.colors.grey200};
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    bottom: 118px;
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    height: 26px;
    position: fixed;
    left: -56px;
    text-align: center;
    text-decoration: none;
    transform: rotate(90deg);
    transition: all 300ms ease-in-out;
    width: 122px;
    z-index: 1000;

    &:hover {
        left: -53px;
    }

    @media print {
        display: none;
    }
`;

const StyledActionText = styled(ActionText)`
    color: ${({ theme }) => theme.colors.white};

    &:hover {
        color: ${({ theme }) => theme.colors.white};
    }
`;
